import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WorkOrderComponent } from './work-order.component';
import { WorkOrderOverviewComponent } from './overview/work-order-overview.component';
import { WorkOrderMaterialsComponent } from './materials/work-order-materials.component';
import { WorkOrderDocumentsComponent } from './documents/work-order-documents.component';
import { DocumentPreviewComponent } from './document-preview/document-preview.component';
import { WorkOrderCommentsComponent } from './comments/work-order-comments.component';
import { ObjectHierarchyComponent } from './objects/object-hierarchy.component';
import { PdfMarkupComponent } from './pdf-markup/pdf-markup.component';
import { WeightReportComponent } from './weight-report/weight-report.component';
import { WorkOrderFeedbackComponent } from './feedback/work-order-feedback.component';

const routes: Routes = [
  {
    component: WorkOrderComponent,
    path: '',
    children: [
      { component: WorkOrderOverviewComponent, path: '' },
      { component: ObjectHierarchyComponent, path: 'objects' },
      { component: WorkOrderMaterialsComponent, path: 'materials' },
      { component: WorkOrderDocumentsComponent, path: 'documents' },
      { component: DocumentPreviewComponent, path: 'document-preview/:document-id' },
      { component: WorkOrderCommentsComponent, path: 'comments/:referenceType/:referenceId' },
      { component: WorkOrderCommentsComponent, path: 'comments/:referenceType' },
      { component: WorkOrderCommentsComponent, path: 'comments' },
      { component: WorkOrderFeedbackComponent, path: 'feedback' },
      { component: WeightReportComponent, path: 'weight-report' },
      { component: PdfMarkupComponent, path: 'pdf-markup/:document-id' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WorkOrderRoutingModule {}
